/**
 * v1.1 增加注释
 */
import React from "react";
import { motion } from "framer-motion";
/**
 * 触摸放大，点击放大
 * @param {} props 
 * @returns 
 */
export default function MotionScale(props) {
  return (
    // {/* 这部分动画是控制触摸放大效果 */}
    <motion.div
      whileHover={{ // 触摸元素的效果
        scale: 1.1, // 缩放:放大
        transition: { duration: 0.1 }, // 设置放大动画的持续时间为0.1秒
      }}
      // drag             //  拖拽效果
      // dragSnapToOrigin // 拖拽回到原点
      whileTap={{
        // 实现(点击)按住的效果
        // backgroundColor:'#000',
        scale: 1,  // 从触摸的方法变成正常大小
        transition: { duration: 0.1 }, // 设置放大动画的持续时间为0.1秒
      }}
    >
      {props.children}
    </motion.div>
  );
}
